// extracted by mini-css-extract-plugin
module.exports = {"VideoFrame":"SingleVideos_VideoFrame__2a3CA","Wrap":"SingleVideos_Wrap__lKHAt"};